<template>
    <Box :title="'资产转科('+Total+'台)'" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee=false">
            <div class="ArrayItems items" v-for="item in list"
                @click="$router.push({name: 'PropertyDetails', params: {item,pageState:pageState} })">
                <div>
                    <img src="@/assets/img/Icon_1.png" />
                    <div>
                        <p class="ellipsis">{{item.SBMC}}</p>
                        <div>
                            <div>
                                <p>资产编号：</p>
                                <p>规格型号：</p>
                                <p>使用科室：</p>
                            </div>
                            <div>
                                <p class="ellipsis">{{item.SBBH}}</p>
                                <p class="ellipsis">{{item.SBXH}}</p>
                                <p class="ellipsis">{{item.SYKSMC}}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <span>{{item.SBZT}}</span> <img src="../../assets/img/right.png" />
                        </div>
                        <div @click.stop="$router.push({name: 'ChangeDepartment', params: {item}})">申请转科</div>
                    </div>
                </div>
                <div>
                    <span>启用日期</span>
                    <span>{{$format(item.QYRQ,'YYYY-MM-DD')}}</span>
                </div>
            </div>
        </LoadingFooter>
        <transition name="fade">
            <div class="menu" key="1" v-show="IsSee">
                <Field title="资产名称" placeholder="请输入" type='input' @onMessage="x=>search.SBMC=x" />
                <Field title="使用科室" placeholder="请选择" type='manufacturer' name='departmentList'
                    @manuconfirm="search.KS=arguments[0].a" />
                <Field title="规格型号" placeholder="请输入" type='input' @onMessage="e=>search.SBXH=e" />
                <Field title="是否附属资产" :tabSelected="search.PJBZ" type="teb"
                    :data="[{id:'',name:'全部'},{id:'Y',name:'是'},{id:'N',name:'否'}]"
                    @onMessage="search.PJBZ=arguments[0].id" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition>
    </Box>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'ScrapList',
        data() {
            return {
                search: {
                    PJBZ: '',
                    SBBH: null,
                    SBMC: null,
                    KS: null,
                    SBXH: null,
                },
                loading: true,
                finished: false,
                list: [],
                IsSee: false, //是否显示
                page: 1,
                Total: 0,
                pageState: true,
            }
        },
        components: {
            Box,
            Field,
            LoadingFooter
        },
        activated() {
            this.list = [];
            this.loadDataDefault();
        },
        methods: {
            serach() {
                this.IsSee = false;
                this.page = 1;
                this.Total=0;
                this.list=[];
                this.loadDataDefault();
            },
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.page += 1;
                    this.loadDataDefault();
                }
            },loadDataDefault(){//加载默认数据
                this.$get('api/Property/GetChangeDeparmentList',{
                    KSBH:this.search.KS||"",
                    GKHM:this.$UserInfo.UserId,
                    STORE:this.$UserInfo.StoreCode,
                    SBBH:this.search.SBBH||"",
                    SBMC:this.search.SBMC||"",
                    SBXH:this.search.SBXH||"",
                    PJBZ:this.search.PJBZ,
                    pageIndex:this.page,
                    pageSize:10,
                    }).then(result=>{
                        try{
                            result=eval("(" + result + ")");
                            this.Total=result.total;
                            for(let i=0;i<result.rows.length;i++){
                                this.list.push(result.rows[i]);
                            }
                            if (this.page*10 >= this.Total) {
                                this.loading = false;
                                this.finished = true;
                            }else this.loading=false;
                        }catch(e){
                            this.$Toast('系统异常,请联系管理员!');
                        }
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;

                        &>p {
                            color: $TEXT-DARK-COLOR;
                            font-weight: bold;
                            font-size: 32px;
                            margin-bottom: 18px;
                            width: 330px;
                            display: flex;
                        }

                        &>div {
                            display: flex;

                            p {
                                color: #999;
                                font-size: 26px;
                                line-height: 45px;
                                height: 45px;
                            }

                            &>div {
                                &:last-child {
                                    p {
                                        width: 170px;
                                    }
                                }
                            }
                        }
                    }

                    &:last-child {
                        &>div {
                            &:first-child {
                                color: $TEXT-DARK-COLOR;
                                font-size: 26px;
                                display: flex;
                                justify-content: center;

                                span {
                                    margin-left: 70px;
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                }
                            }

                            &:last-child {
                                margin-left: 25px;
                                width: 152px;
                                height: 61px;
                                background: $THEME-COLOR;
                                border-radius: 30px;
                                text-align: center;
                                line-height: 61px;
                                font-size: 26px;
                                color: $TEXT-LIGHT-COLOR;
                                margin-top: 62px;
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/changeDepartmentList/changeDepartmentList.vue